<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    @hideModal="hideModal()"
    size="lg"
  >
    <template #header>
      {{$t('routes.EXSBItemCreate')}}
    </template>
    <template #body>
      <Create></Create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/BusinessBundle/exsbitem/Create'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ItemCreateModal',
  components: {
    BaseModal,
    Create
  },
  computed: {
    ...mapGetters({
      isVisible: 'exsbitem/createModal/isVisible'
    })
  },
  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbitem/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
